import React from 'react';
import { useQuery } from '@apollo/client';
import { Button } from 'anf-core-react';
import { ERROR_MESSAGE } from '../Messages/Messages';
import { TmntText, LoyaltyCard } from '../Common';
import { MY_POINTS_LOYALTY_QUERY } from './operations';
import { analytics } from '../../tools/analytics';

/**
 * MyPointsCard Component
 *
 * This component displays the user's loyalty points information and progress towards the next reward.
 * It fetches the points data using a GraphQL query and updates analytics data when the query completes.
 */
export default function MyPointsCard() {
  // Use Apollo's useQuery hook to fetch loyalty points data
  // The query returns current points and max points needed for next reward
  const { data = {}, loading: queryLoading, error } = useQuery(MY_POINTS_LOYALTY_QUERY, {
    // Callback function that executes when the query successfully completes
    onCompleted: ({
      config: {
        myPointsCurrentProgressBarValue,
        myPointsMaxProgressBarValue,
      },
    }) => {
      // Update analytics with current points value
      analytics.loyalty.setPoints(myPointsCurrentProgressBarValue);

      // Calculate and update analytics with points needed for next reward
      // This is the difference between max points and current points
      analytics.loyalty.setPointsToNextReward(
        myPointsMaxProgressBarValue - myPointsCurrentProgressBarValue,
      );
    },
  });

  if (queryLoading) return null;
  if (error) return ERROR_MESSAGE;

  const { textFor = {}, config = {} } = data;

  const {
    myPointsTitle,
    myPointsDescription,
    pointsHistoryTitle,
    minValueLabelProgressBar,
    maxValueLabelProgressBar,
  } = textFor;
  const {
    pointsHistoryUrl, myPointsCurrentProgressBarValue, myPointsMaxProgressBarValue,
  } = config;

  return (
    <LoyaltyCard
      title={myPointsTitle?.value}
      description={<TmntText tmnt={myPointsDescription} />}
      progressBarCurrentValue={myPointsCurrentProgressBarValue}
      progressBarMaximumValue={myPointsMaxProgressBarValue}
      minValueLabelProgressBar={minValueLabelProgressBar?.value}
      maxValueLabelProgressBar={maxValueLabelProgressBar?.value}
      progressBarClassName="myPointsProgressBar"
    >
      <Button classList="points-history-btn" variant="tertiary-dark" isFullWidth href={pointsHistoryUrl}>
        {pointsHistoryTitle.value}
      </Button>
    </LoyaltyCard>
  );
}
